<template>
    <div v-if="cart.couponDiscount>0 || cart.totalPackageDiscount>0" class="vc-checkout-total--container">
        <div class="vc-checkout-total">
            <span class="vc-checkout-total__label">Subtotal <tooltip :text="tooltipText.subtotal"/></span>
            <span class="vc-checkout-total__price">{{cart.total+cart.couponDiscount + cart.totalPackageDiscount | displayPrice }}</span>
        </div>
        <div class="vc-checkout-total">
            <span class="vc-checkout-total__label">Package discount <tooltip :text="tooltipText.packageDiscount"/></span>
            <span class="vc-checkout-total__price"> <template v-if="cart.totalPackageDiscount>0"> &#8722; </template> {{cart.totalPackageDiscount | displayPrice }}</span>
        </div>
        <div class="vc-checkout-total">
            <span class="vc-checkout-total__label">Coupon discount <tooltip :text="tooltipText.couponDiscount"/></span>
            <span class="vc-checkout-total__price"> <template v-if="cart.couponDiscount>0"> &#8722; </template> {{cart.couponDiscount | displayPrice }}</span>
        </div>
        <div class="vc-checkout-total--separator"></div>
        <div class="vc-checkout-total">
            <span class="vc-checkout-total__label vc-checkout-total__label--final">Total</span>
            <span class="vc-checkout-total__price vc-checkout-total__price--final">{{cart.total | displayPrice(true) }}</span>
        </div>
    </div>
    <div v-else>
        <div class="vc-checkout-total vc-checkout-total--no-discount">
            <span class="vc-checkout-total__price--no-discount">Total: {{cart.total | displayPrice(true) }}</span>
        </div>
    </div>
</template>

<script>
import Tooltip from "../../../../shared/components/tooltip"
export default {
    name: "checkout-total",
    data(){
        return {
            tooltipText: {
                subtotal: "Total before discounts",
                couponDiscount: "Total coupon discount",
                packageDiscount: "Total package discount",
            }
        }
    },
    computed: {
        cart() {
            return this.$store.state.cart;
        }
    },
    components: {Tooltip}
}
</script>

<style lang="scss" scoped>
    .vc-checkout-total {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin-top: .5rem;
        font-weight: 400;
        &--no-discount{
            margin-top: 15px;
        }
        &--container{
            background-color: var(--background-emphasized);
            padding:15px;
            border-radius: 5px;
            margin-top:15px;
        }

        &--separator{
            border-top: 1px solid var(--primary-text-color-faded-more);
            width:100%;
            height: 5px;
            margin-top:5px;
        }

        &__label {
            position: relative;
            top: -1px;
            color: var(--primary-text-color);
            font-size: 14px;

            &--final{
                font-size: 18px;
                font-weight: 600;
            }
        }

        &__price {
            color: var(--primary-text-color);
            font-size: 14px;
            margin-left: auto;
            font-weight: 600;

            &--no-discount{
               font-size: 18px;
               color: var(--highlight-color);
               font-weight: 600;
            }

            &--final{
                font-size:18px;
                color: var(--highlight-color);
            }
        }
    }
</style>
